import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js' 
import '../../assets/scripts/number.js'

// 数字滚动
var istrue = true;
var s = $(window).scrollTop();
if (s >$(".nei-banner").offset().top + $("header").height()  && istrue) {
    $(".timer").each(count);
    function count(a) {
        var b = $(this);
        a = $.extend({},
        a || {},
        b.data("countToOptions") || {});
        b.countTo(a)
    };
    istrue = false;
}


$(window).on("scroll",
function() {
   var s = $(window).scrollTop();
    if (s >$(".nei-banner").offset().top + $("header").height()  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };  
    
})

var swiper1 = new Swiper(".section5 .mySwiper", {
    spaceBetween: '1.25%',
    slidesPerView: 5,
    speed:4000,//匀速时间
    loop:true,
    autoplay: {
    	delay: 0,
    	stopOnLastSlide: false,
    	disableOnInteraction: false,
    },
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            spaceBetween: '1.25%',
            slidesPerView: 5,
        },
        768: {  //当屏幕宽度小于等于768
            spaceBetween: '1.25%',
            slidesPerView: 4,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 2,
            spaceBetween: 10,
        }
    }
});


$(".section6 .pic img").eq(0).addClass("active");
$(".section6 .project-nav p").eq(0).addClass("active");
$(".section6 .right ul").eq(0).addClass("active");
$(".section6 .project-nav p").hover(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".section6 .pic img").eq(index).addClass("active").siblings().removeClass("active");
    $(".section6 .right ul").eq(index).addClass("active").siblings().removeClass("active");
})

var swiper2 = new Swiper(".section7 .mySwiper", {
    spaceBetween: '3.35%',
    slidesPerGroup: 3,
    slidesPerView: 3,
    speed:700,
    navigation: {
        nextEl: ".section7 .swiper-button-next",
        prevEl: ".section7 .swiper-button-prev",
    },
    pagination: {
        el: ".section7 .swiper-pagination",
      },
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: '3.35%',
        },
        768: {  //当屏幕宽度小于等于768
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 20,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 10,
        }
    }
});

var swiper3 = new Swiper(".section8 .mySwiper", {
    spaceBetween: '3.3125%',
    slidesPerView: 4,
    speed:4000,//匀速时间
    loop:true,
    autoplay: {
    	delay: 0,
    	stopOnLastSlide: false,
    	disableOnInteraction: false,
    },
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            spaceBetween: '3.3125%',
            slidesPerView: 4,
        },
        768: {  //当屏幕宽度小于等于768
            spaceBetween: '2%',
            slidesPerView: 3,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 2,
            spaceBetween: 10,
        }
    }
});
